<template lang="html">
  <div class="examplex">
    <vs-select autocomplete v-model="currentRestaurant" class="selectRestaurant w-full">
      <vs-select-item class="selectRestaurant" :key="index" :value="item.id" :text="item.name" v-for="(item,index) in restaurantsUser" />
    </vs-select>
  </div>
</template>

<script>
    import {mapMutations, mapGetters} from 'vuex'
    export default {
        computed: {
            currentRestaurant: {
                get () {
                    this.$store.commit('recoverCurrentRestaurant')
                    return this.$store.getters.getCurrentRestaurant
                },
                set (value) {
                    this.$store.commit('setCurrentRestaurant', value)
                    location.reload();
                }
            },
            ...mapGetters({
                restaurantsUser: 'getRestaurantsUser',
            })
        },
        methods: {
            ...mapMutations({
                recoverRestaurantsUser: 'recoverRestaurantsUser',
                recoverCurrentRestaurant: 'recoverCurrentRestaurant',
                setCurrentRestaurant: 'setCurrentRestaurant'
            })
        },
        created () {
            this.recoverRestaurantsUser()
            this.recoverCurrentRestaurant()
        }
    }
</script>
